module.exports = __webpack_public_path__ + "static/media/paragon-innovation-summit.1437a99b.jpeg";